export enum TipoSituacaoTramiteEnum {
    "Em Preenchimento" = 1,
    "Em Assinatura" = 2,
    "Rejeitado" = 3,
    "Cancelado" = 4,
    "Assinado" = 5,
    "Arquivado" = 6,
    "Finalizado com assinaturas pendentes" = 8
}
